import type { HeaderAssemblyEntity } from "building-types/framing/headerAssemblyTypes";
import type { ForeignEntityId } from "building-types/handles/foreignEntityId";
import uid from "common/utils/uid";

export function headerAssemblyNewEntity(
  name: string,
  headerCount: number,
  headerComponentId: ForeignEntityId<"FRAMING_COMPONENT">,
  id: string = uid(),
  sortIndex: number = 0,
): HeaderAssemblyEntity {
  return {
    name,
    headerCount,
    headerComponentId,
    entityType: "HEADER_ASSEMBLY",
    id,
    sortIndex,
  };
}
